<mat-form-field i18n>
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input
        [formGroup]="range"
        [rangePicker]="picker"
        [min]="minDate"
        [max]="maxDate"
    >
        <input matStartDate formControlName="start" placeholder="Start date" />
        <input matEndDate formControlName="end" placeholder="End date" />
    </mat-date-range-input>
    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-date-range-picker #picker></mat-date-range-picker>

    @if (range.controls.start.hasError('matStartDateInvalid')) {
        <mat-error>Invalid start date</mat-error>
    }
    @if (range.controls.end.hasError('matEndDateInvalid')) {
        <mat-error>Invalid end date</mat-error>
    }
</mat-form-field>

<table mat-table [dataSource]="dataSources" class="mat-elevation-z8" i18n>
    <!-- Timeframe Column -->
    <ng-container matColumnDef="timeframe">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">{{ element.timeframe }}</td>
    </ng-container>

    <!-- Dataset Group Columns (for header only) -->
    @for (group of columnGroups; track $index) {
        <ng-container [matColumnDef]="group.key + '_group'">
            <th
                mat-header-cell
                *matHeaderCellDef
                [attr.colspan]="group.columns.length"
                class="text-center"
            >
                {{ group.label }}
            </th>
        </ng-container>
    }

    <!-- Dynamic Columns for Each Dataset and Month-Year -->
    @for (dataset of datasets; track dataset; let datasetIndex = $index) {
        @for (
            monthYear of monthYears;
            track monthYear;
            let monthIndex = $index
        ) {
            <ng-container
                [matColumnDef]="
                    dataset.key +
                    '_' +
                    monthYear.month.toLowerCase() +
                    '_' +
                    monthYear.year
                "
            >
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    [ngClass]="{ 'first-in-group': monthIndex === 0 }"
                    class="text-center"
                >
                    {{ monthYear.month.substring(0, 3) + ' ' + monthYear.year }}
                </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    {{
                        element[
                            dataset.key +
                                '_' +
                                monthYear.month.toLowerCase() +
                                '_' +
                                monthYear.year
                        ]
                    }}
                </td>
            </ng-container>
        }
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumnGroups"></tr>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
